import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProcessoService } from '@app/services/processo.service';
import { PeticaoService } from '@app/services/peticao.service';
import { Peticao } from '@app/models/peticao';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-peticao-online',
  templateUrl: './peticao-online.component.html'
})
export class PeticaoOnlineComponent implements OnInit {

  processoId: number;
  lstPeticao: Peticao[];
  modalRef: BsModalRef;
  aguardandoSolicitacao: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private peticaoService: PeticaoService,
    private processoService: ProcessoService,
    private modalService: BsModalService,
    private utilitarioService: UtilitarioService
  ) {
    this.aguardandoSolicitacao = false;
  }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
      });
    this.peticaoService.obterTodos().subscribe(data => this.lstPeticao = data);
  }

  public gerarPeticao(peticao: Peticao, template: TemplateRef<any>) {
    this.aguardandoSolicitacao = true;
    this.peticaoService.gerarPeticao(this.processoId, peticao.Id).toPromise()
      .then((data) => {
        this.utilitarioService.saveAs(data, peticao.Descricao + peticao.Extensao);
      })
      .then(() => this.aguardandoSolicitacao = false);
    this.openModal(template);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
}
